import { AsyncPipe, DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { BlockComponent } from "@components/container-block/block.component";
import { PageComponent } from "@components/page/page.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Observable, catchError, map, of } from "rxjs";
import { HeaderComponent } from "~app/common/components/header/header.component";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { ISystemInfo } from "~app/pages/about/models/system-info";
import { environment } from "~environments/environment";

@Component({
    selector: "rask-about",
    templateUrl: "./about.component.html",
    styleUrls: ["./about.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        BlockComponent,
        DatePipe,
        TranslatePipe,
        AsyncPipe,
        HeaderComponent
    ]
})
export class AboutComponent {
    about: ISystemInfo;
    licenses: Observable<string[]>;

    private readonly authenticationService = inject(AuthenticationService);

    constructor(
        private readonly http: HttpClient
    ) {
        const userData = this.authenticationService.getUserData();
        this.about = {
            userName: userData.userName,
            azureUserId: userData.azureUserId,
            roles: userData.roles,
            releaseInfoBuildNumber: environment.releaseInfo.buildNumber,
            releaseInfoReleaseId: environment.releaseInfo.releaseId ?? "",
            releaseInfoPublishDate: environment.releaseInfo.publishDate ?? ""
        };

        this.licenses = http.get("assets/3rdpartylicenses.txt", { responseType: "text" }).pipe(
            map(text => text
                .split(/^-{10,}$/m)
                .map(s => s.trim())
                .filter(s => s.length > 0)
            ),
            catchError(() => of(["Licensfil hittades inte"]))
        );
    }
}
